"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventContractV2 = void 0;
const base_1 = require("../../../base");
const RetailerEventDataContract_1 = require("./RetailerEventDataContract");
const TenantEventDataContract_1 = require("./TenantEventDataContract");
const DeviceEventDataContract_1 = require("./DeviceEventDataContract");
const UserEventContract_1 = require("./UserEventContract");
class EventContractV2 {
    constructor(params) {
        this.tenant = base_1.GreenlineEvent.create(TenantEventDataContract_1.TenantEventDataContract, params);
        if (params.retailerId) {
            this.retailer = base_1.GreenlineEvent.create(RetailerEventDataContract_1.RetailerEventDataContract, params);
        }
        if (params.deviceId) {
            this.device = base_1.GreenlineEvent.create(DeviceEventDataContract_1.DeviceEventDataContract, params);
        }
        if (params.userId) {
            this.user = base_1.GreenlineEvent.create(UserEventContract_1.UserEventDataContract, params);
        }
    }
}
exports.EventContractV2 = EventContractV2;
//# sourceMappingURL=EventContract.js.map